import { LOAD_PAYMENT_METHOD } from './mutation-types'

// Bip scanner caisse via Web Audio API (pas de fichier, fonctionne partout)
function playBeep({ frequency = 1050, duration = 90, volume = 0.35, type = 'sine' } = {}) {
    try {
        const ctx = new (window.AudioContext || window.webkitAudioContext)()
        const osc  = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.type = type
        osc.frequency.value = frequency
        gain.gain.setValueAtTime(volume, ctx.currentTime)
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration / 1000)
        osc.start(ctx.currentTime)
        osc.stop(ctx.currentTime + duration / 1000)
        osc.onended = () => ctx.close()
    } catch (e) {}
}

// Bip succès : court et aigu (scanner supermarché)
const audio = { play: () => playBeep({ frequency: 1050, duration: 90 }) }

// Bip erreur : plus grave et plus long
const audioError = { play: () => playBeep({ frequency: 320, duration: 250, type: 'square', volume: 0.2 }) }

Object.filter = (obj, predicate) =>
    Object.keys(obj)
        .filter(key => predicate(key))
        .reduce((res, key) => (res[key] = obj[key], res), {})

export const priceWithPromotion = function (product) {
    let price = priceWithoutRem(product)
    if (product.type_promotion === 'fixed') {
        price = price - parseFloat(product.price_promotion)
    } else if (product.type_promotion === 'percent') {
        price = price - ((price * parseFloat(product.price_promotion)) / 100)
    }
    return price
}

export const productPriceFormated = function (product) {
    return $formatCurrency(null, parseFloat(priceWithPromotion(product)))
}

export const realProductPriceFormated = function (product) {
    return $formatCurrency(null, parseFloat(priceWithoutRem(product)))
}

export const Price = function (product, price) {
    if (product.remId) return priceWithRem(product, price)
    return price
}

export const productPrice = function (product) {
    let price = parseFloat(priceWithPromotion(product).toFixed(2)) * product.number
    return Price(product, price)
}

export const getStateProductQuantity = function (state, product) {
    let extendedProductNumber = state.products[product.id] || { number: 0 }
    return extendedProductNumber.number
}

export const getNewQuantityValue = function (productNumber, digit) {
    if (parseFloat(productNumber) === 0 && !productNumber.toString().includes('.')) {
        productNumber = 0
    }
    if (digit === '.') {
        if (!productNumber.toString().includes(digit)) {
            productNumber = productNumber + '' + digit + ''
        }
    } else {
        if (productNumber.toString().length === 1) {
            if (parseFloat(productNumber) === 0) {
                productNumber = digit
            } else {
                productNumber = productNumber + '' + digit + ''
            }
        } else {
            let t = productNumber + '' + digit + ''
            productNumber = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t
        }
    }
    return productNumber
}

export const getDiscountValue = function (productDiscount, digit) {
    if (parseFloat(productDiscount) === 0 && !productDiscount.toString().includes('.')) {
        productDiscount = 0
    }
    if (digit === '.') {
        if (!productDiscount.toString().includes(digit)) {
            productDiscount = productDiscount + '' + digit + ''
        }
    } else {
        if (productDiscount.toString().length === 1) {
            if (parseFloat(productDiscount) === 0) {
                productDiscount = digit
            } else {
                productDiscount = productDiscount + '' + digit + ''
            }
        } else {
            let t = productDiscount + '' + digit + ''
            productDiscount = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t
        }
    }
    if (productDiscount > 100) return 100
    return productDiscount
}

export const getPriceOffsetValue = function (productPriceOffset, digit) {
    if (parseFloat(productPriceOffset) === 0 && !productPriceOffset.toString().includes('.')) {
        productPriceOffset = 0
    }
    if (digit === '.') {
        if (!productPriceOffset.toString().includes(digit)) {
            productPriceOffset = productPriceOffset + '' + digit + ''
        }
    } else {
        if (productPriceOffset.toString().length === 1) {
            if (parseFloat(productPriceOffset) === 0) {
                productPriceOffset = digit
            } else {
                productPriceOffset = productPriceOffset + '' + digit + ''
            }
        } else {
            let t = productPriceOffset + '' + digit + ''
            productPriceOffset = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3)) : t
        }
    }
    return productPriceOffset
}

export const addProductToCart = async function (context, product) {
    let extendedProductNumber = getStateProductQuantity(context.state, product)
    const response = await window.axios.post('pos/product/check/quantity', {
        quantity: extendedProductNumber,
        product_id: product.id
    }).then(r => r.data)

    if (response.quantity) {
        await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
        await context.commit('ADD_PRODUCT', product)
        audio.play()
    } else {
        toastr.error('Quantité insuffisante dans votre stock')
        audioError.play()
        await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
    }
}

export const addProductToCartByScanner = async function (context, { product, quantity }) {
    let extendedProductNumber = getStateProductQuantity(context.state, product) + parseInt(quantity) - 1
    let response
    try {
        response = await window.axios.post('pos/product/check/quantity', {
            quantity: extendedProductNumber,
            product_id: product.id
        }).then(r => r.data)
    } catch (e) {
        const msg = e?.response?.data?.message || 'Erreur serveur'
        toastr.error(msg)
        audioError.play()
        throw e
    }

    if (response.quantity) {
        await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
        await context.commit('ADD_SCANNER_PRODUCT', { selectedProduct: product, quantity })
        audio.play()
    } else {
        toastr.error('Quantité insuffisante dans votre stock')
        audioError.play()
        await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
    }
}

export const addBundleToCart = async function (context, bundle) {
    await context.commit('ADD_BUNDLE', bundle)
    audio.play()
}

export const deleteBundleFromCart = async function (context, bundleId) {
    context.commit('DELETE_BUNDLE', { bundle_id: bundleId })
}

export const setBundleQuantity = async function (context, { bundle, quantity }) {
    context.commit('SET_BUNDLE_QUANTITY', { bundle, quantity })
}

export const setProductQuantity = async function (context, { product, quantity }) {
    context.commit('SET_PRODUCT_QUANTITY', { product, quantity })
}

export const deleteProductByIdFromCart = async function (context, productId) {
    context.commit('DELETE_PRODUCT', { product_id: productId })
}

export const IncrementProductNumber = async function (context, product) {
    context.commit('INCREMENT_PRODUCT', product)
}

export const DecrementProductNumber = async function (context, product) {
    context.commit('DECREMENT_PRODUCT', product)
}

export const deleteFromCart = async function (context) {
    context.commit('DELETE_PRODUCT', context.state.currentProduct)
}

export const changeCurrentProduct = function (context, product) {
    context.commit('CHANGE_CURRENT_PRODUCT', product)
}

export const resetProductDigit = function (context) {
    context.commit('RESET_PRODUCT_DIGIT')
}

export const quantityChangeByPad = async function (context, digit) {
    let product = context.state.products[context.state.currentProduct.product_id]

    if (!product.digit) {
        if (digit !== '.') {
            const response = await window.axios.post('pos/product/check/quantity/withPad', {
                quantity: digit,
                product_id: context.state.currentProduct.product_id,
            }).then(r => r.data)

            if (response.quantity) {
                await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
                product.number = digit
                product.hasPromotion = response.hasPromotion
                product.price_ttc = response.price_ttc
                product.price_ttc_promo = response.price_ttc_promo
                let carts = JSON.parse(localStorage.getItem('carts' + this.getters['session/getSellerId']))
                let currentCart = carts[context.state.currentCart]
                await this.commit('posCart/SET_PRODUCT', context.state.products)
                currentCart.products = context.state.products
                carts = { ...carts, [context.state.currentCart]: currentCart }
                localStorage.setItem('carts' + this.getters['session/getSellerId'], JSON.stringify(carts))
                product.digit = true
            } else {
                toastr.error('Quantité insuffisante dans votre stock')
                await audioError.play()
                await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
            }
        } else {
            const response = await window.axios.post('pos/product/check/quantity/withPad', {
                quantity: getNewQuantityValue(product.number, digit),
                product_id: context.state.currentProduct.product_id,
            }).then(r => r.data)

            if (response.quantity) {
                await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
                product.number = getNewQuantityValue(product.number, digit)
                product.hasPromotion = response.hasPromotion
                product.price_ttc = response.price_ttc
                product.price_ttc_promo = response.price_ttc_promo
                let carts = JSON.parse(localStorage.getItem('carts' + this.getters['session/getSellerId']))
                let currentCart = carts[context.state.currentCart]
                await this.commit('posCart/SET_PRODUCT', context.state.products)
                currentCart.products = context.state.products
                carts = { ...carts, [context.state.currentCart]: currentCart }
                localStorage.setItem('carts' + this.getters['session/getSellerId'], JSON.stringify(carts))
                product.digit = true
            } else {
                toastr.error('Quantité insuffisante dans votre stock')
                await audioError.play()
                await this.commit('posCategories/CHANGE_PRODUCT_INFORMATIONS', response)
            }
        }
    } else {
        const response = await window.axios.post('pos/product/check/quantity/withPad', {
            quantity: getNewQuantityValue(product.number, digit),
            product_id: context.state.currentProduct.product_id,
        }).then(r => r.data)

        if (response.quantity) {
            product.number = getNewQuantityValue(product.number, digit)
            product.hasPromotion = response.hasPromotion
            product.price_ttc = response.price_ttc
            product.price_ttc_promo = response.price_ttc_promo
            let carts = JSON.parse(localStorage.getItem('carts' + this.getters['session/getSellerId']))
            let currentCart = carts[context.state.currentCart]
            await this.commit('posCart/SET_PRODUCT', context.state.products)
            currentCart.products = context.state.products
            carts = { ...carts, [context.state.currentCart]: currentCart }
            localStorage.setItem('carts' + this.getters['session/getSellerId'], JSON.stringify(carts))
            product.digit = true
        } else {
            toastr.error('Quantité insuffisante dans votre stock')
            await audioError.play()
        }
    }
}

export const quantityChangeByBackspace = function (context) {
    context.commit('QUANTITY_CHANGE_BY_BACKSPACE', context.state.currentProduct)
}

export const discountChangeByBackspace = function (context) {
    context.commit('DISCOUNT_CHANGE_BY_BACKSPACE', context.state.currentProduct)
}

export const priceOffsetChangeByBackspace = function (context) {
    context.commit('PRICE_OFFSET_CHANGE_BY_BACKSPACE', context.state.currentProduct)
}

export const loadReductions = async function (context) {
    if (!context.state.reductions.loaded) {
        const response = await window.axios.get('admin/shop/reductions').then(r => r.data)
        context.commit('ADD_REDUCTIONS', response)
        context.state.reductions.loaded = true
    }
}

/**
 * Confronte le panier courant au stock de la boutique. Le panier est gardé sur l'appareil :
 * un article peut y rester alors que son stock est tombé à zéro depuis (vendu entre-temps,
 * ici ou en ligne). Les lignes concernées sont retirées ou réduites, et le caissier prévenu —
 * plutôt qu'un refus « quantité indisponible » au moment d'encaisser.
 */
// Panier qui vient d'être encaissé : il reste affiché (écran facture) jusqu'à « Nouvelle vente ».
// Son stock vient justement de baisser — ce n'est pas un panier à corriger.
let soldCartIndex = null

export const reconcileWithStock = async function (context) {
    if (soldCartIndex !== null && soldCartIndex === context.state.currentCart) return

    const products = context.state.products || {}
    const bundles = context.state.bundles || {}
    if (!Object.keys(products).length && !Object.keys(bundles).length) return

    let availability
    try {
        availability = (await window.axios.post('pos/cart/availability', { cart: products, bundles })).data
    } catch (e) {
        return // session fermée ou réseau : le contrôle à l'encaissement reste le garde-fou
    }

    const t = (key, params) => window.i18n.global.t(key, params)
    const messages = []
    const describe = (line) => messages.push(line.allowed > 0
        ? t('cart.stock_reduced', { name: line.name, quantity: line.allowed })
        : t('cart.stock_removed', { name: line.name }))

    ;(availability.products || []).forEach((line) => {
        const product = Object.values(context.state.products).find(item => item.product_id === line.product_id)
        if (!product || line.allowed >= parseFloat(product.number)) return
        context.commit('SET_PRODUCT_QUANTITY', { product, quantity: line.allowed })
        describe(line)
    })
    ;(availability.bundles || []).forEach((line) => {
        const bundle = Object.values(context.state.bundles).find(item => item.bundle_id === line.bundle_id)
        if (!bundle || line.allowed >= parseFloat(bundle.number)) return
        context.commit('SET_BUNDLE_QUANTITY', { bundle, quantity: line.allowed })
        describe(line)
    })

    if (messages.length) {
        window.toastr['warning'](messages.join('<br>'), t('cart.stock_changed'), { timeOut: 8000, escapeHtml: false })
    }
}

// vente à crédit : le client paie plus tard (acompte éventuel dans payments)
const creditFields = (state) => ({
    ...(state.credit ? { credit: true, due_date: state.creditDueDate || null } : {}),
    // bon de commande payé par cette vente
    ...(state.orderForm ? { order_form_id: state.orderForm.id } : {}),
})

export const storeCheckout = async function (context) {
    const response = await window.axios.post('pos/checkout', {
        ...creditFields(context.state),
        cart: context.state.products,
        bundles: context.state.bundles,
        client: this.getters['posContact/getClientId'],
        note: context.state.note,
        payments: context.state.payments,
        loyalty_reward_id: context.state.loyaltyRewardId || null,
        discount: context.state.discount || 0,
    }).then(r => r.data)
    soldCartIndex = context.state.currentCart
    return response
}

// Pré-contrôle (session, stock, acompte…) avant un paiement Mobile Money : rien n'est enregistré.
export const precheckCheckout = async function (context, payments) {
    return window.axios.post('pos/checkout/precheck', {
        ...creditFields(context.state),
        cart: context.state.products,
        bundles: context.state.bundles,
        client: this.getters['posContact/getClientId'],
        note: context.state.note,
        payments,
        loyalty_reward_id: context.state.loyaltyRewardId || null,
        discount: context.state.discount || 0,
    }).then(r => r.data)
}

// Bon de commande : panier courant enregistré sur le serveur (mis à jour s'il vient d'un bon)
export const saveOrderForm = async function (context) {
    const state = context.state
    const payload = {
        products: Object.values(state.products || {}),
        bundles: Object.values(state.bundles || {}),
        client: this.getters['posContact/getClientId'],
        note: state.note || null,
        discount: state.discount || 0,
        amount_total: this.getters['posCart/getTotalAmountWithLoyalty'] || 0,
    }
    const response = state.orderForm
        ? await window.axios.put(`pos/order-forms/${state.orderForm.id}`, payload, { silent: true })
        : await window.axios.post('pos/order-forms', payload, { silent: true })
    return response.data
}

// Bon de commande rouvert : s'il est déjà ouvert dans un panier on y retourne (modifs conservées),
// sinon chargé dans le panier courant s'il est vide, sinon dans un nouveau
export const openOrderForm = async function (context, id) {
    const form = (await window.axios.get(`pos/order-forms/${id}`)).data
    const sellerId = this.getters['session/getSellerId']
    const carts = JSON.parse(localStorage.getItem('carts' + sellerId)) || {}
    const openedIn = Object.keys(carts).find(index => carts[index]?.orderForm?.id === id)
    if (openedIn !== undefined) {
        if (parseInt(openedIn) !== context.state.currentCart) {
            context.commit('CHANGE_CURRENT_CART', { cart: openedIn, sellerId })
            context.dispatch('reconcileWithStock')
        }
        return form
    }
    if (Object.keys(context.state.products || {}).length || Object.keys(context.state.bundles || {}).length) {
        context.commit('ADD_CART')
        this.commit('posContact/RESET_CONTACT')
    }
    context.commit('LOAD_ORDER_FORM', form)
    this.commit('posContact/SET_CLIENT_ID', {
        id: form.customer ? form.customer.id : null,
        sellerId: this.getters['session/getSellerId'],
        cart: context.state.currentCart,
    })
    return form
}

export const normalizationInvoice = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('generate-invoice-normalized/' + id).then(resolve).catch(reject)
    })
}

export const verifyInvoiceNormalization = ({ commit }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('verify-invoice-normalized/' + id).then(resolve).catch(reject)
    })
}

export const verifyInvoiceCountryBeninConfig = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('verify-country-invoice-configuration').then(resolve).catch(reject)
    })
}

export const checkNormalizationKey = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('check-normalization-key').then(resolve).catch(reject)
    })
}

export const resetCart = function (context) {
    soldCartIndex = null
    context.commit('RESET_CART')
    context.commit('SET_NOTE', '')
    context.commit('SET_PAYMENTS_MODE', [])
    this.commit('posContact/RESET_CONTACT')
    this.dispatch('loyalty/clearPosMembership')
}

export const remiseOnProduct = async function (context, digit) {
    let product = context.state.products[context.state.currentProduct.product_id]
    product.remise = getDiscountValue(product.remise, digit)
    let carts = JSON.parse(localStorage.getItem('carts' + this.getters['session/getSellerId']))
    let currentCart = carts[context.state.currentCart]
    await this.commit('posCart/SET_PRODUCT', context.state.products)
    currentCart.products = context.state.products
    carts = { ...carts, [context.state.currentCart]: currentCart }
    localStorage.setItem('carts' + this.getters['session/getSellerId'], JSON.stringify(carts))
}

export const priceOnProduct = async function (context, digit) {
    let product = context.state.products[context.state.currentProduct.product_id]
    product.price_offset = getPriceOffsetValue(product.price_offset, digit)
    let carts = JSON.parse(localStorage.getItem('carts' + this.getters['session/getSellerId']))
    let currentCart = carts[context.state.currentCart]
    await this.commit('posCart/SET_PRODUCT', context.state.products)
    currentCart.products = context.state.products
    carts = { ...carts, [context.state.currentCart]: currentCart }
    localStorage.setItem('carts' + this.getters['session/getSellerId'], JSON.stringify(carts))
}

export const loadPaymentMethods = ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('ecommerce/get/paymentMethod/collection').then((response) => {
            commit(LOAD_PAYMENT_METHOD, response.data.payments)
            resolve(response)
        }).catch(reject)
    })
}
